import { AcademicStatusType } from '@/models/learning/academic-situation';

export const statusDropdownLabels: Record<AcademicStatusType, string> = {
  [AcademicStatusType.Pending]: 'Inscrição em andamento',
  [AcademicStatusType.EnrollmentPending]: 'Matrícula pendente',
  [AcademicStatusType.InProgress]: 'Em andamento',
  [AcademicStatusType.Interrupted]: 'Interrompido',
  [AcademicStatusType.Canceled]: 'Cancelado',
  [AcademicStatusType.Completed]: 'Concluído',
};

export const statusTransitions: Record<AcademicStatusType, AcademicStatusType[]> =
  {
    [AcademicStatusType.Pending]: [],
    [AcademicStatusType.EnrollmentPending]: [
      AcademicStatusType.InProgress,
      AcademicStatusType.Canceled,
    ],
    [AcademicStatusType.InProgress]: [
      AcademicStatusType.Canceled,
      AcademicStatusType.Interrupted,
      AcademicStatusType.Completed,
    ],
    [AcademicStatusType.Interrupted]: [
      AcademicStatusType.InProgress,
      AcademicStatusType.Canceled,
    ],
    [AcademicStatusType.Canceled]: [],
    [AcademicStatusType.Completed]: [],
  };
